<template>
  <div class="">
    <navigation></navigation>
    <banner mainen="CULTURE" mainzh="企业文化"></banner>
    <div class="main-con">
      <vmenu></vmenu>
      <div id="culture">
        <div class="container">
          <div class="culture-title">
            <div class="title-zh">企业文化</div>
            <div class="title-en">CULTURE</div>
          </div>
          <div class="culture-content">
            <div class="line line1">
              <div class="one align-right">
                <div class="one-container">
                  <div class="culture-content-title">诚信服务</div>
                  <div class="culture-content-text">
                    承诺一致直到客户满意为止
                  </div>
                  <div class="one-index">01</div>
                  <div class="border-bottom"></div>
                </div>
              </div>
              <div class="one align-left">
                <div class="one-container">
                  <div class="culture-content-title">品质第一</div>
                  <div class="culture-content-text">
                    把产品和质量作为我们的生命线，不断创新产品，坚守质量标准。
                  </div>
                  <div class="one-index">02</div>
                  <div class="border-bottom"></div>
                </div>
              </div>
            </div>
            <div class="line line2">
              <div class="one align-right">
                <div class="one-container">
                  <div class="culture-content-title">低碳节能</div>
                  <div class="culture-content-text">
                    不断优化，节约资源，化繁为简，减少对环境的污染
                  </div>
                  <div class="one-index">03</div>
                  <div class="border-bottom"></div>
                </div>
              </div>
              <div class="one align-left">
                <div class="one-container">
                  <div class="culture-content-title">追求卓越</div>
                  <div class="culture-content-text">对价值和品质的不断追求</div>
                  <div class="one-index">04</div>
                  <div class="border-bottom"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vfooter></vfooter>
  </div>
</template>
<script>
import navigation from "@/components/sub/Nav";
import vfooter from "@/components/sub/Footer";
import banner from "@/components/sub/Banner";
import vmenu from "@/components/sub/Menu";
export default {
  name: "home",
  components: {
    navigation,
    vfooter,
    banner,
    vmenu,
  },
};
</script>
<style scoped>
#culture {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #fafafa url("../assets/imgs/b6bg.png") center center no-repeat;
  background-size: auto 469px;
}
#culture .container {
  width: 1200px;
  padding: 69px 0 100px 0;
}

#culture .culture-title {
  width: 100%;
  text-align: center;
}

#culture .culture-title .title-zh {
  height: 26px;
  font-size: 26px;
  font-weight: bold;
  color: #000000;
  line-height: 30px;
}
#culture .culture-title .title-en {
  height: 11px;
  font-size: 14px;
  font-weight: 600;
  color: #999999;
  line-height: 30px;
  opacity: 0.5;
}

#culture .culture-content .line {
  display: flex;
  justify-content: space-between;
}

#culture .culture-content .line1{
  margin-top: 50px;
}

#culture .culture-content .line2{
  margin-top: 118px;
}

#culture .culture-content .line .one {
  width: 400px;
  height: 200px;
  position:relative;
}

#culture .culture-content .line .one .one-index{
  display:none;
  position: absolute;
  font-family: Arial;
  top:-40px;
  width:109px;
  height:65px;
  font-size: 86px;
  font-weight: bold;
  color:#D91414;
}

#culture .culture-content .line .one .border-bottom{
  display: none;;
  position:absolute;
  left:29px;
  bottom:28px;
  width:348px;
  height: 4px;
  background-color:#D91414;
}

#culture .culture-content .line .one:hover {
  background: #ffffff;
  box-shadow: 0px 1px 30px 5px rgba(115, 115, 115, 0.18);
}

#culture .culture-content .line .one:hover .border-bottom,
#culture .culture-content .line .one:hover .one-index
{
  display: block;
}

#culture .culture-content .line .one .one-container {
  padding: 45px 29px 28px 31px;
}

#culture .culture-content .line .align-left {
  text-align: left;
}
#culture .culture-content .line .align-left .one-index{
  right:0;
}
#culture .culture-content .line .align-right {
  text-align: right;
}
#culture .culture-content .line .align-right .one-index{
  left:0;
}


#culture .culture-content .line .one .culture-content-title {
  height: 21px;
  font-size: 22px;
  font-weight: 600;
  color: #333333;
  line-height: 30px;
}

#culture .culture-content .line .one .culture-content-text {
  margin-top: 24px;
  height: 18px;
  font-size: 18px;
  font-weight: 400;
  color: #999999;
  line-height: 27px;
}
</style>



// WEBPACK FOOTER //
// src/page/Culture.vue